<!--The content below is only a placeholder and can be replaced.-->
<div class="container-fluid padding-30">
  <div class="col-md-1 col-lg-1 assesment-modal">
    <!-- basic modal -->
    <app-shared-modal
      titleText="Import Test"
      [isOpen]="modalIsVisible"
      confirmButtonText="Confirm"
      [disableConfirm]="isDisableUpload"
      [focusElementOnClose]="ngModelDropdown"
      (show)="modalIsVisible = true"
      (close)="closeUploadModal()"
      (cancel)="closeUploadModal()"
      (confirm)="uploadTestData()"
      [removeAriaDescribedByAfterFocus]="true"
    >
      <div class="row set-margin">
        <div class="col-12">
          <h3 class="import-text">Import a Test Builder File</h3>
        </div>
        <div class="col-12">
          <p class="text-color">
            Upload an existing Test Builder zip file to import a new test to the
            “My Tests” page.
          </p>
          <p class="text-color">
            <strong>Note:</strong> Test Builder will only import files from the
            same ISBN from which the test was originally created.
          </p>
        </div>
      </div>
      <div class="row">
        <label class="left-upload" for="upload-file">Upload Zip File<span aria-hidden="true">:</span></label>
        <div class="upload-div">
          <input
            id="upload-file"
            type="file"
            #myInput
            accept=".zip"
            (change)="onChange($event.target.files)"
          />
          <button
            *ngIf="fileData"
            type="button"
            class="clear-button"
            (click)="clearFile(myInput, $event)"
            (keydown.enter)="clearFile(myInput, $event)"
            (keyup.space)="clearFile(myInput, $event)"
            aria-label="Remove attached file"
            title="Remove attached file">
            <img src="../../../assets/img/trash-icon.svg" alt="Trash icon for removing attached file" aria-hidden="true" />
          </button>
        </div>
         <div class="col-12 p-0 assesment-error" *ngIf="showErrorMessage">
          <app-alert [type]="alertType.Error" (close)="closeAlert('manual')">
            {{ errorMessage }}
          </app-alert>
        </div>
      </div>
    </app-shared-modal>
  </div>
  <div class="col-md-12 col-lg-12 ml-0 mt-0 main-content">
    <div class="row margin-top-1 margin-bottom-30 heading-row">
      <div class="col-12 col-md-3 pl-0 page-title">
        <h1 class="workspace_header margin-top-one">My Tests</h1>
      </div>
      <div class="col-12 col-md-9 text-right p-0 parent-search-div" id="parent-search-div">
        <div class="search-component">
          <search-component
            (valueChange)="displayInputText($event, true, true)"
          ></search-component>
          <div 
            id="search-results-status"
            class="sr-only"
            role="status">
            {{ searchResultsAnnouncement }}
          </div>
        </div>
        <div class="text-right header-actions">
            <app-button
              (click)="refreshList()"
              [purpose]="_buttonPurpose.Secondary"
              class="refresh-btn"
            >
              <i id="refreshSpinner" class="fa fa-refresh"></i>
              <span class="ml-4">Refresh List</span>
            </app-button>
            <app-dropdown
              class="icon margin-top-1 assesment-dropdown"
              id="ngmodel-dropdown"
              #ngModelDropdown
              [options]="ngModelOptions"
              [selected]="selectedOption"
              name="ngModelDropdown"
              [placeholder]="createTestText"
              (selectionChange)="createTest($event)"
              syncWidths="true"
            ></app-dropdown>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 p-0" *ngIf="showSuccessMessage">
        <app-alert [type]="alertType.Success" (close)="closeAlert('manual')">
          {{ alertMessage }}
        </app-alert>
      </div>
      <div class="col-12 p-0" *ngIf="showExportErrorMessage">
        <app-alert [type]="alertType.Error" (close)="closeAlert('manual')">
          There was a problem exporting your test. Please try again.
        </app-alert>
      </div>
    </div>
    <div class="assessment-list-table">
     <table  #assessmentListTable>
      <caption class="sr-only">My Tests Dashboard</caption>
      <thead>
        <tr class="row justify-content-center font-color collection-list-header">
          <th scope="col" class="col-lg-3" #columnHeader>
            <button type="button"
              (click)="sort('collection_title')" 
              class="header-sort-button margin-colnstitle"
              (keydown)="handleKeyPress($event, 'collection_title')"
              aria-label="Test Title"
              data-column="collection_title">
              <div class="icon-container-title">
                <i class="dpg-icon dpg-icon-hamburger-white cursor-style" aria-hidden="true"></i>
                <i class="dpg-icon {{ sortAscDsc.collection_title }} cursor-style" aria-hidden="true"></i>
              </div>
              <span class="cursor-style">Test Title</span>
            </button>
          </th>
          <th scope="col" class="col-lg-2 text-right" #columnHeader>
            <button (click)="sort('modified')" 
              class="header-sort-button align-left margin-colnstitle"
              (keydown)="handleKeyPress($event, 'modified')"
              aria-label="Date Modified"
              data-column="modified">
              <div class="icon-container">
                <i class="dpg-icon dpg-icon-hamburger-white cursor-style" aria-hidden="true"></i>
                <i class="dpg-icon {{ sortAscDsc.modified }} cursor-style" aria-hidden="true"></i>
              </div>
              <span class="cursor-style">Date modified</span>
            </button>
          </th>
          <th scope="col" class="col-lg-2 text-right" #columnHeader>
            <button (click)="sort('isbnTitle')" 
              class="header-sort-button align-left margin-colnstitle"
              (keydown)="handleKeyPress($event, 'isbnTitle')"
              aria-label="Product Title"
              data-column="isbnTitle">
              <div class="icon-container-isbn">
                <i class="dpg-icon dpg-icon-hamburger-white cursor-style" aria-hidden="true"></i>
                <i class="dpg-icon {{ sortAscDsc.isbnTitle }} cursor-style" aria-hidden="true"></i>
              </div>
              <span class="cursor-style">Product Title</span>
            </button>
          </th>
          <th scope="col" class="col-lg-2 text-right" #columnHeader>
            <button (click)="sort('isbnAuthor')" 
              class="header-sort-button align-left margin-colnstitle"
              (keydown)="handleKeyPress($event, 'isbnAuthor')"
              aria-label="Author"
              data-column="isbnAuthor">
              <div class="icon-container-author">
                <i class="dpg-icon dpg-icon-hamburger-white cursor-style" aria-hidden="true"></i>
                <i class="dpg-icon {{ sortAscDsc.isbnAuthor }} cursor-style" aria-hidden="true"></i>
              </div>
              <span class="cursor-style">Author</span>
            </button>
          </th>
          <th scope="col" class="col-lg-1 text-right" #columnHeader>
            <button (click)="sort('isbnEdition')" 
              class="header-sort-button align-left margin-colnstitle"
              (keydown)="handleKeyPress($event, 'isbnEdition')"
              aria-label="Edition"
              data-column="isbnEdition">
              <div class="icon-container-edition">
                <i class="dpg-icon dpg-icon-hamburger-white cursor-style" aria-hidden="true"></i>
                <i class="dpg-icon {{ sortAscDsc.isbnEdition }} cursor-style" aria-hidden="true"></i>
              </div>
              <span class="cursor-style">Edition</span>
            </button>
          </th>
          <th scope="col" class="col-lg-1 text-right" #columnHeader>
            <button (click)="sort('modified_format')" 
              class="header-sort-button align-left margin-colnstitle"
              (keydown)="handleKeyPress($event, 'modified_format')"
              aria-label="Format"
              data-column="modified_format">
              <div class="icon-container-avl">
                <i class="dpg-icon dpg-icon-hamburger-white cursor-style" aria-hidden="true"></i>
                <i class="dpg-icon {{ sortAscDsc.modified_format }} cursor-style" aria-hidden="true"></i>
              </div>
              <span class="cursor-style">Format</span>
            </button>
          </th>
          <th scope="col" class="col-lg-1 text-center sticky-col">
            <span [attr.aria-hidden]="isAnyModalOpen ? true : null">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody
        id="assessment-list"
        *ngIf="assessmentListdata.collections != undefined"
      >
        <tr #currentRow 
          class="row1 border-bottom"
          *ngFor="
            let assessment of assessmentListdata.collections;
            let testInd = index
          "
        >
          <td class="col-lg-3 table-row-child">
            <label
              id="assessment_collection_title_{{testInd}}"
              class="ml-2"
              title="{{ assessment.collection_title }}"
              [innerHtml]="
                assessment.collection_title
                  | truncate : [50, '...']
                  | linebreak : 36
              "
            ></label>
          </td>
          <td class="col-lg-2 text-right">
            <div class="table-row-child align-left dateAlign">
              <label class="assesment-position">{{
                assessment.modified | date : "medium"
              }}</label>
            </div>
          </td>
          <td class="col-lg-2 text-right">
            <div class="table-row-child align-left">
              <label class="assesment-position">{{
                assessment.isbnTitle != null ? assessment.isbnTitle : "N/A"
              }}</label>
            </div>
          </td>
          <td class="col-lg-2 text-right">
            <div class="table-row-child align-left">
              <label class="assesment-position">{{
                assessment.isbnAuthor != null ? assessment.isbnAuthor : "N/A"
              }}</label>
            </div>
          </td>
          <td class="col-lg-1 text-right">
            <div class="table-row-child align-left">
              <label class="assesment-position">{{
                assessment.isbnEdition != null ? assessment.isbnEdition : "N/A"
              }}</label>
            </div>
          </td>
          <td class="col-lg-1 p-0 pl-4 text-right">
            <div
              class="align-left"
              [ngClass]="
                assessment.collection_title.length > 36
                  ? 'availabilityTwoAlign'
                  : 'availabilityOneAlign'
              "
            >
              <label
                *ngIf="
                  assessment.qtiStatus == 'pending' ||
                  assessment.docxStatus == 'pending'
                "
                class="assesment-position textstyle status"
                >Pending</label
              >
              <label
                *ngIf="assessment.qtiStatus == 'available'"
                class="assesment-position status"
                ><button
                  type="button"
                  class="link-style"
                  (click)="
                    downloadFile(
                      assessment.collection_id,
                      qti,
                      assessment.downloadQTI
                    )
                  "
                  [attr.aria-label]="'QTI Download ' + assessment.collection_title"
                  >QTI
                </button>
              </label>
              <label
                *ngIf="assessment.docxStatus == 'available'"
                class="assesment-position status"
                ><button
                type="button"  
                class="link-style"
                  (click)="
                    downloadFile(
                      assessment.collection_id,
                      docx,
                      assessment.downloadDOCX
                    )
                  "
                  [attr.aria-label]="'DOCX Download ' + assessment.collection_title"
                  >DOCX
            </button>
              </label>
              <label
                *ngIf="
                  assessment.docxStatus == 'notAvailable' &&
                  assessment.qtiStatus == 'notAvailable' &&
                  assessment.expiredQTI === false &&
                  assessment.expiredDOCX === false
                "
                class="assesment-position textstyle status"
                >Draft</label
              >
              <label
                *ngIf="
                  assessment.docxStatus == 'notAvailable' &&
                  assessment.qtiStatus == 'notAvailable' &&
                  (assessment.expiredQTI === true ||
                    assessment.expiredDOCX === true)
                "
                class="assesment-position status"
                ><button
                  type="button"  
                  class="link-style"
                  (click)="
                    resync(assessment.collection_id, assessment.collection_title)
                  "
                  [attr.aria-label]="'Regenerate ' + assessment.collection_title"
                  >Regenerate
            </button>
              </label>
            </div>
          </td>
          <td class="col-lg-1 text-right sticky-col">
            <div class="table-row-child" (click)="setKebabIndex(testInd, currentRow)">
              <kebab-component
                [collection]="assessment"
                [kebabMenuItems]="kebabMenu"
                [show_kebab]="testInd === kebabIndex"
                (renameCollection)="renameCollection($event)"
                [message]="message"
                (refreshList)="populateTestList(true)"
                (showSuccessAlert)="showSuccessAlert($event)"
                (closeKebabOnEscape)="kebabIndex = -1"
                [showKebabAbove]="displayKebabAbove"
                (modalStateChanged)="onKebabModalStateChange($event)"
              ></kebab-component>
            </div>
          </td>
        </tr>
      </tbody>
    </table>  
    </div>
    <div class="row h-20 mt-5 mb-5 justify-content-center align-items-center">
      <app-pager
        class="d-flex flex-column flex-md-row align-items-center"
        [length]="collectionLength"
        [pageIndex]="pageNumber"
        [pageSize]="itemsPerPage"
        (page)="pageChanged($event)"
      >
      </app-pager>
    </div>
  </div>
</div>
